import React from 'react'

import { Column } from '../../../components/layouts/columns'
import { Button } from '../../../components/ui/button'
import { Table } from '../../../components/ui/table'
import { Input } from '../../../components/ui/input'
import { Page } from '../../../components/layouts/page'
import { useClientCampaign } from './hooks/useClientCampaign.js'
import { ModalAddCampaign } from './modal/modalAddCampaign'
import { Icon } from '../../../components/icons'

function renderExpandableText(text, id, openState, setOpenState, limit = 20) {
  if (!text) return ''

  const isOpen = openState[id]
  const short = text.length > limit ? text.slice(0, limit) + '...' : text

  const toggle = () => {
    setOpenState((prev) => ({ ...prev, [id]: !prev[id] }))
  }

  return (
    <div>
      <span>{isOpen ? text : short}</span>
      <br />
      {text.length > limit && (
        <button className="button is-text is-size-7 ml-2" onClick={toggle}>
          {isOpen ? 'ver menos' : 'ver mais'}
        </button>
      )}
    </div>
  )
}

export const ClientCampaign = () => {
  const {
    loading,
    search,
    setSearch,
    dataFiltered,
    FetchGetDatas,
    setModalAdd,
    modalAdd,
    HandleAddCampaigns,
    openMsg,
    setOpenMsg,
    infosContext,
  } = useClientCampaign()

  return (
    <>
      <ModalAddCampaign
        loading={loading}
        setActive={setModalAdd}
        active={modalAdd}
        actions={{
          add: async (values) => {
            await HandleAddCampaigns(values)
          },
        }}
        infoContext={infosContext}
      />

      <Page.Root className="is-fullwidth">
        <Column.Root className="mt-6 pt-6">
          <Column.Content>
            <p className="subtitle is-size-3">
              <Icon size={50} className="mr-2">
                user_arrows
              </Icon>
              Promover Campanhas
            </p>
          </Column.Content>
          <Column.Content className="has-text-right">
            <Button.Root align="right">
              <Button.Content>
                <Button.Bt
                  color="is-dark"
                  colorText="has-text-white"
                  action={() => {
                    FetchGetDatas()
                  }}
                  loading={loading}
                >
                  <Icon size={15}>sync</Icon>
                </Button.Bt>
              </Button.Content>
              <Button.Content>
                <Button.Bt
                  color="is-success"
                  colorText="has-text-white"
                  action={() => {
                    setModalAdd(true)
                  }}
                  loading={loading}
                >
                  +
                </Button.Bt>
              </Button.Content>
            </Button.Root>
          </Column.Content>
        </Column.Root>
        {dataFiltered && !loading ? (
          <>
            <Column.Root className="">
              <Column.Content>
                <Input.Root>
                  <Input.Contents alignIcon={'left'}>
                    <Input.Prompt value={search} setValue={setSearch} placeholder="Pesquisar..."></Input.Prompt>
                    <Input.Icon align="is-left">
                      <Icon size={20}>search</Icon>
                    </Input.Icon>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
            </Column.Root>
            <Column.Root className="">
              <Column.Content>
                <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered ">
                  <Table.Head>
                    <Table.Row>
                      <Table.Cell>Nome</Table.Cell>
                      <Table.Cell>Mensagem</Table.Cell>
                      <Table.Cell>Criado em</Table.Cell>
                      <Table.Cell>Criado por</Table.Cell>
                      <Table.Cell>Enviado há</Table.Cell>
                      <Table.Cell>Entregues</Table.Cell>
                      <Table.Cell>Não Entregues</Table.Cell>
                      <Table.Cell>Com Erro</Table.Cell>
                      <Table.Cell>Situação</Table.Cell>
                    </Table.Row>
                  </Table.Head>
                  <Table.Body>
                    {(dataFiltered || []).map((value) => {
                      // console.log(value)
                      return (
                        <>
                          <Table.Row key={value.id}>
                            <Table.Cell className="is-size-7 is-vcentered">{value?.title}</Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered">
                              {renderExpandableText(value?.msg, value.id, openMsg, setOpenMsg)}
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered" size={100}>
                              {value?.dt_created}
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered" size={100}>
                              {value?.createdBy}
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered" size={100}>
                              {infosContext?.n_staff_total}
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered" size={100}>
                              {value?.sendsOk}
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered" size={100}>
                              {Number(infosContext?.n_staff_total) -
                                (Number(value?.sendsOk) + Number(value?.sendError))}
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered" size={100}>
                              {value?.sendError}
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered" size={100}>
                              {value?.status || 'Em Andamento'}
                            </Table.Cell>
                          </Table.Row>
                        </>
                      )
                    })}
                  </Table.Body>
                </Table.Root>
              </Column.Content>
            </Column.Root>
          </>
        ) : (
          <Column.Root>
            <Column.Content></Column.Content>
            <Column.Content>
              <Icon>loading</Icon>
            </Column.Content>
            <Column.Content></Column.Content>
          </Column.Root>
        )}
      </Page.Root>
    </>
  )
}
